module.exports = __webpack_public_path__ + "7e37fb704c07a5412b843eeda979648d.svg";